// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__Aptgn","listItem":"styles_listItem__jlWL8"};